import WalletManagementScreen from "./WalletManagementScreen";

export default WalletManagementScreen;
